import request from './.request-edge.js'

/**
 * 读取当前实验最近的快照列表（时间倒序）
 */
export function listRecentShortcuts(camera) {
  return request({
    url: `shortcut?of=recent`,
    method: 'get'
  })
}

/**
 * 查询某次实验的所有快照记录
 * @param {Number} experimentId 实验id
 * @param {Number} pageNum 页码
 */
export function listShortcuts(experimentId, pageNum) {
  return request({
    url: `shortcut/${experimentId}?by=experiment-id&page-num=${pageNum || 0}`,
    method: 'get'
  })
}

/**
 * 查询某次实验的加标的快照记录
 * @param {Number} experimentId
 * @returns
 */
export function listShortcutsMarked(experimentId) {
  return request({
    url: `shortcut/${experimentId}?by=experiment-id&marked-only=yes`,
    method: 'get'
  })
}

/**
 * 对当前实验手动生成一次快照
 */
export function shortcutOnce() {
  return request({
    url: `shortcut`,
    method: 'post'
  })
}

/**
 * 读取指定id的快照的详细信息（会带上快照信息）
 * @param {*} id
 * @returns
 */
export function getShortcut(id) {
  return request({
    url: `shortcut/${id}`,
    method: 'get'
  })
}

export function saveShortcutMemo(data) {
  return request({
    url: `shortcut?of=memo`,
    method: 'put',
    data: data
  })
}

export function markShortcut(data) {
  return request({
    url: `shortcut?of=marked`,
    method: 'put',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/shortcut.js